import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/bahathlogo.webp'


const _hoisted_1 = { class: "text-primary relative" }
const _hoisted_2 = { class: "p-6 md:p-10 absolute w-full" }
const _hoisted_3 = { class: "h-screen grid grid-cols-1 content-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-32 h-32 sm:w-48 sm:h-48 place-self-center",
  width: "32",
  height: "32",
  alt: "Bahath Logo"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "font-primary text-primary text-4xl sm:text-5xl md:text-6xl p-2 mx-auto" }, " bahath ", -1)
const _hoisted_6 = { type: "submit" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "font-secondary pt-3 text-center" }, "- or -", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fixed bottom-0 right-0 p-2 font-secondary text-black" }, " by _catFurr ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SolidButtonVue = _resolveComponent("SolidButtonVue")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserNavVue = _resolveComponent("UserNavVue")!
  const _component_TextInputWithErrorVue = _resolveComponent("TextInputWithErrorVue")!
  const _component_HollowButtonVue = _resolveComponent("HollowButtonVue")!
  const _component_EmptyButtonVue = _resolveComponent("EmptyButtonVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/error?type=300",
        class: "float-left"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SolidButtonVue, {
            text: 'docs',
            class: "w-16"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_UserNavVue, {
        class: "float-right",
        "keep-expanded": true
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("form", {
        class: "flex flex-row mx-auto p-2",
        action: "/redirect",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.goToForm()), ["prevent"]))
      }, [
        _createVNode(_component_TextInputWithErrorVue, {
          modelValue: _ctx.code,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
          "is-error": !_ctx.getCleanedCode(_ctx.code) && _ctx.triedSubmit,
          class: "text-sm sm:text-base md:text-lg"
        }, null, 8, ["modelValue", "is-error"]),
        _createElementVNode("button", _hoisted_6, [
          _createVNode(_component_HollowButtonVue, {
            class: "w-24 m-1",
            text: 'begin'
          })
        ])
      ], 32),
      _hoisted_7,
      _createVNode(_component_router_link, {
        to: "/studio",
        class: "p-2 flex mx-auto w-48"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_EmptyButtonVue, { text: 'make a new form' })
        ]),
        _: 1
      })
    ]),
    _hoisted_8
  ]))
}